export default class UpdateSolutionError extends Error {

}
